import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { Page } from '@/components/page'
import { ProviderSearch } from '@/features/providers/ProviderSearch'

export interface ProvidersSearch {
  q?: string
}

export const Route = createFileRoute('/providers')({
  component: ProvidersPage,
  validateSearch: (search: Record<string, unknown>): ProvidersSearch => ({
    q: typeof search.q === 'string' && search.q ? search.q : undefined,
  }),
})

function ProvidersPage() {
  const { q } = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <Page title="Distributors" description="Look parts up at a distributor and copy one across.">
      <ProviderSearch
        query={q ?? ''}
        onQueryChange={(query) => navigate({ search: { q: query || undefined } })}
      />
    </Page>
  )
}
